import { AxiosError, AxiosResponse } from "axios"
import { popupBasicError, popupError } from "@/utils/notification"

export function handleApiError(error: unknown): string {
    // Shows a popup with detailed error message if available
    // Return a string with the basic error message for further escalation

    let errorMessage: string = "An error occurred"

    if (error && typeof error === "object" && ("isAxiosError" in error || error instanceof AxiosError)) {
        const axiosErr = error as AxiosError<any>
        const data = axiosErr.response?.data
        errorMessage = data?.message || axiosErr.message || "Network error"

        if (errorMessage === "Validation error") {
            let html = "<div class='text-start'>"
            if (data?.extra?.fields && typeof data.extra.fields === "object") {
                for (const [key, value] of Object.entries(data.extra.fields)) {
                    html += `<p>${key}: ${value}</p>`
                }
            }
            html += "</div>"

            let detailStr = ""
            try {
                detailStr = typeof data?.detail === "string" ? data.detail : JSON.stringify(data?.detail)
            } catch {
                detailStr = String(data?.detail || "")
            }

            popupError("Validation error", detailStr, html)
        } else {
            popupBasicError(errorMessage)
        }
        return errorMessage
    }

    if (error instanceof Error) {
        errorMessage = error.message
    } else {
        try {
            errorMessage = JSON.stringify(error)
        } catch {
            errorMessage = String(error)
        }
    }

    popupBasicError(errorMessage)
    return errorMessage
}

export function ensureApiStatusCode(response: AxiosResponse, expectedStatusCode: number) {
    // Check response for status code; otherwise raises exception with error message that can be picked up by handleApiError
    if (response.status != expectedStatusCode) {
        throw new Error(`Unexpected response code ${response.status}!`)
    }
}
